import { render, staticRenderFns } from "./buildSubcontractAddOrUpdate.vue?vue&type=template&id=6ce3fb28&scoped=true&"
import script from "./buildSubcontractAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./buildSubcontractAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce3fb28",
  null
  
)

export default component.exports